import {RawLocation, Route} from "vue-router/types/router";
import {GtmScript} from "@/router/gtm-script";

export class GtmRouterNext {

    /**
     * GTMのタグを通知するパス
     * 通知するパスはここに記載してください。
     * RouterのbeforeEnterにおいて、GtmRouterNext.nextを実行していないパスは
     * この配列に定義してもGTMに通知されないので注意してください。
     */
    static readonly GTM_TARGET_PATH: string[] = [
        '/',
        '/client/mypage',
        '/client/customer-code',
        '/client/regist',
        '/client/regist-confirm',
        '/client/regist-complete'
    ];

    /** gtm.jsスクリプト */
    gtm: GtmScript = null;

    /** RouteのTo */
    to: Route = null;

    /** RouteのFrom */
    from: Route = null;

    /** Routerのnext関数 */
    routerNext: (to?: RawLocation | false | void) => void = null;

    /**
     * コンストラクタ
     * @param gtm RouteのTo
     * @param to RouteのTo
     * @param from RouteのFrom
     * @param nextFunc Routerのnext関数
     */
    constructor(gtm: GtmScript, to: Route, from: Route, nextFunc: (to?: RawLocation | false | void) => void) {
        this.gtm = gtm;
        this.to = to;
        this.from = from;
        this.routerNext = nextFunc;
    }

    /**
     * GTMに通知した後に次画面に遷移します。
     * @param to Routerのnext関数の引数
     * @param sendNoticeContentsLoad GTMに通知するかのフラグ true - 通知する / false - 通知しない
     */
    public next(to?: RawLocation | false | void, sendNoticeContentsLoad: boolean = true) {
        // 対象のパスの場合、GTMに通知する
        let path = to ? to.toString() : this.to.path;

        if (sendNoticeContentsLoad && GtmRouterNext.GTM_TARGET_PATH.includes(path)) {
            this.gtm.noticeContentsLoad(path, this.to.query);
        }

        // 画面遷移する
        this.routerNext(to);
    }
}